import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesOrderComponent } from './sales-order.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SalesOrderComponent],
  exports: [SalesOrderComponent],
})
export class SalesOrderModule { }
